import { useEffect, useState } from "react";
import { Users, UserCheck, ShieldCheck, Crown, Flag, IndianRupee, Heart, Send } from "lucide-react";
import { BarChart, Bar, ResponsiveContainer, XAxis, Tooltip } from "recharts";
import { api } from "@/lib/api";
import { FullSpinner } from "@/components/States";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return <FullSpinner label="Loading stats…" />;
  const s = d.stats;
  const cards = [
    ["Total Users", s.total_users, Users], ["Active (7d)", s.active_users, UserCheck],
    ["Verified", s.verified_profiles, ShieldCheck], ["Pending Verify", s.pending_verification, ShieldCheck],
    ["Premium", s.premium_users, Crown], ["Lifetime", s.lifetime_users, Crown],
    ["Open Reports", s.reports_open, Flag], ["Suspended", s.blocked_accounts, Flag],
    ["Interests", s.interests, Send], ["Matches Made", s.matches_made, Heart],
    ["Revenue", `₹${s.revenue}`, IndianRupee],
  ];
  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <h1 className="font-serif text-3xl font-bold">Overview</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3">
        {cards.map(([label, val, Icon]) => (
          <div key={label} className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl p-4">
            <Icon className="w-5 h-5 text-[#C59B27] mb-2" />
            <div className="font-serif text-2xl font-bold text-[#E2C382]">{val}</div>
            <div className="text-xs text-[#D8B4B9]">{label}</div>
          </div>
        ))}
      </div>
      <div className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl p-5">
        <h2 className="font-serif text-lg font-semibold mb-4">Registrations (last 7 days)</h2>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={d.registration_trend}>
            <XAxis dataKey="date" stroke="#D8B4B9" fontSize={12} />
            <Tooltip contentStyle={{ background: "#1A090D", border: "1px solid #781826", borderRadius: 12, color: "#FAF5F0" }} />
            <Bar dataKey="count" fill="#C59B27" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
